import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LoyaltyLandingPageHowItWorksItem from './LoyaltyLandingPageHowItWorksItem'
import Typography from 'LuxKit/Typography/Typography'

const HowItWorksSection = styled(Pane)`
  padding: ${rem(48)} 0;
`

const HowItWorksItems = styled.div`
  display: grid;
  gap: ${rem(44)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export interface LoyaltyLandingPageHowItWorksDetails {
  title: string
  description: string
  type: 'earn' | 'savings' | 'status'
}

const howItWorksItems: Array<LoyaltyLandingPageHowItWorksDetails> = [
  {
    title: 'Earn points on every booking',
    description: 'Look for the rewards badge on offers to see how many points you’ll earn. Keep an eye out for bonus offers too.',
    type: 'earn',
  },
  {
    title: 'Turn points into savings',
    description: 'Use your points to pay for all or part of your next escape — simply select the amount at checkout and save instantly.',
    type: 'savings',
  },
  {
    title: 'Unlock tiers with Status Credits',
    description: 'Earn Status Credits every time you travel. Each credit brings you closer to the next tier — and even greater rewards.',
    type: 'status',
  },
]

interface Props {
  onJoin?: () => void
}

function LoyaltyLandingPageHowItWorksSection(props: Props) {
  const { onJoin } = props

  return <HowItWorksSection background="neutral-seven">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={48}>
        <VerticalSpacer gap={8}>
          <Heading variant="heading2" align="center">How it works</Heading>
          <BodyText variant="large" align="center">
            Earn points and Status Credits every time you travel — and unlock a world of rewards.
          </BodyText>
        </VerticalSpacer>
        <HowItWorksItems>
          {howItWorksItems.map(item => <LoyaltyLandingPageHowItWorksItem
            key={item.title}
            item={item}
          />)}
        </HowItWorksItems>
        {onJoin && <Typography align="center">
          <TextButton kind="primary" onClick={onJoin}>
            Join now - it's free
          </TextButton>
        </Typography>}
      </VerticalSpacer>
    </LayoutContainer>
  </HowItWorksSection>
}

export default LoyaltyLandingPageHowItWorksSection
